import styled from 'styled-components';
import { tokens } from '../../../design/tokens';

export const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  width: 100%;
  padding-top: 16px;
  margin-top: 8px;
  border-top: 1px solid ${tokens.color.railGraphite};

  /* Os botões do átomo têm margin-top próprio; aqui a barra já espaça. */
  > button {
    margin-top: 0;
  }
`;

export const Hint = styled.span`
  margin-left: auto;
  color: ${tokens.color.textAsh};
  font-size: ${tokens.font.caption.size};

  @media (max-width: 600px) {
    margin-left: 0;
    width: 100%;
  }
`;
